module.exports = __webpack_public_path__ + "static/media/collaborate.4689cde6.webp";